/* PARK: one product and inventory, with audience-specific presentation. */
(() => {
  if (window.parkAudienceInstalled) return;
  window.parkAudienceInstalled = true;

  function audience() {
    const value = new URL(window.location.href).searchParams.get('park_audience');
    return value === 'men' || value === 'women' ? value : null;
  }

  function productLink(link, chosenAudience) {
    if (!link || !link.hasAttribute('href')) return;
    const url = new URL(link.getAttribute('href'), window.location.href);
    if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    url.searchParams.set('park_audience', chosenAudience);
    link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  }

  async function initialise(scope = document) {
    const chosenAudience = audience();
    if (!chosenAudience) return;
    await customElements.whenDefined('product-gallery');
    if (!scope.isConnected && scope !== document) return;

    scope.querySelectorAll('product-gallery[data-park-gallery-key]').forEach(gallery => {
      const section = gallery.closest('.shopify-section') || gallery.parentElement;
      const key = gallery.dataset.parkGalleryKey;
      const template = Array.from(section.querySelectorAll('template[data-park-gallery-template]'))
        .find(item => item.dataset.parkGalleryTemplate === key && item.dataset.parkAudience === chosenAudience);
      if (!template) return; // This product/colour uses its normal gallery as the fallback.
      const replacement = template.content.firstElementChild.cloneNode(true);
      gallery.replaceWith(replacement);

      // Keep the fixed add-to-cart thumbnail consistent without changing the product form.
      const firstImage = replacement.querySelector('.product-gallery__media > img');
      if (firstImage) {
        section.querySelectorAll('product-quick-add variant-media').forEach(media => {
          const container = document.createElement('div');
          const image = firstImage.cloneNode(true);
          image.className = 'rounded-xs';
          image.style.width = '80px';
          image.style.height = '80px';
          image.style.objectFit = 'contain';
          container.append(image);
          media.replaceWith(container);
        });
      }
    });

    scope.querySelectorAll('.shopify-section--main-product a[href]').forEach(link => productLink(link, chosenAudience));
    if (scope.matches?.('.shopify-section--main-product')) {
      scope.querySelectorAll('a[href]').forEach(link => productLink(link, chosenAudience));
    }
  }

  // Colour links use separate product URLs. Preserve this explicit view across them.
  document.addEventListener('click', event => {
    const chosenAudience = audience();
    if (!chosenAudience || !(event.target instanceof Element)) return;
    const link = event.target.closest('.shopify-section--main-product a[href]');
    productLink(link, chosenAudience);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();